import { createFileRoute } from "@tanstack/react-router";
import ActivateCard from "@/pages/ActivateCard";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/activate-card/")({
  head: () => routeHead("/activate-card/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ActivateCard />
  );
}
